/* eslint-disable filenames/match-exported */

import React from 'react';
import { DebugContextStateType } from '~/types';
import DebugContext, { debugContextInitialState } from '.';
interface Props {
  children: React.ReactNode;
}
interface IDebugContextValue {
  actions: {
    update: (context: Partial<DebugContextStateType>) => Promise<void>;
  };
  state: DebugContextStateType;
}
export class DebugContextProvider extends React.Component<Props, DebugContextStateType> {
  state: DebugContextStateType = debugContextInitialState;
  setStateAsync = (state: Partial<DebugContextStateType>): Promise<void> => {
    // eslint-disable-next-line promise/avoid-new
    return new Promise((resolve): void => {
      this.setState(state as DebugContextStateType, resolve);
    });
  };
  _update = async (context: Partial<DebugContextStateType>): Promise<void> => {
    await this.setStateAsync(context);
  };
  _getContextValue(): IDebugContextValue {
    return {
      actions: {
        update: this._update
      },
      state: {
        ...this.state
      }
    };
  }
  render(): React.ReactNode {
    const {
      children
    } = this.props;
    return <DebugContext.Provider value={this._getContextValue()} data-sentry-element="unknown" data-sentry-component="DebugContextProvider" data-sentry-source-file="provider.tsx">
        {children}
      </DebugContext.Provider>;
  }
}
export default DebugContextProvider;